module.exports = __webpack_public_path__ + "static/img/order_reput.67d4363f.png";